import React from 'react';
import styled from 'styled-components';
import { Spring, animated } from 'react-spring';

export const SubTitle = animated(styled.div`
  position: relative;
  text-align: center;
  margin-bottom: 2rem;
  font-weight: 500;
  width: 300px;
  max-width: 100%;
  margin: 0 auto;
`);

export default ({ from, to, children, ...rest }) => (
  <Spring native from={from || { opacity: 0 }} to={to || { opacity: 1 }}>
    {animation => (
      <SubTitle style={animation} {...rest}>
        {children}
      </SubTitle>
    )}
  </Spring>
);
